/**
 * Admin Dashboard - Statistics Cards
 */
import { Building2, Users, DollarSign, TrendingUp } from "lucide-react";

const StatCard = ({ title, value, icon: Icon, trend, color = "#D4AF37" }) => (
  <div className="bg-[#121212] border border-white/5 rounded-lg p-6">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-[#A3A3A3] text-sm">{title}</p>
        <p className="text-3xl font-bold text-white mt-1">{value}</p>
        {trend && (
          <p className={`text-sm mt-2 flex items-center gap-1 ${trend > 0 ? 'text-green-500' : 'text-red-500'}`}>
            <TrendingUp size={14} className={trend < 0 ? 'rotate-180' : ''} />
            {Math.abs(trend)}% vs mes anterior
          </p>
        )}
      </div>
      <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}20` }}>
        <Icon size={24} style={{ color }} />
      </div>
    </div>
  </div>
);

const DashboardStats = ({ properties = [], contacts = [] }) => {
  const totalValue = properties.reduce((sum, p) => sum + (p.price_usd || 0), 0);
  const forSale = properties.filter(p => p.transaction_type === "Venta").length;
  const forRent = properties.filter(p => p.transaction_type === "Alquiler").length;
  
  const stats = [
    { title: "Total Propiedades", value: properties.length, icon: Building2, color: "#D4AF37" },
    { title: "En Venta", value: forSale, icon: Building2, color: "#10B981" },
    { title: "En Alquiler", value: forRent, icon: Building2, color: "#3B82F6" },
    { title: "Contactos", value: contacts.length, icon: Users, color: "#8B5CF6" },
    { title: "Valor Total", value: `$${(totalValue / 1000000).toFixed(1)}M`, icon: DollarSign, color: "#F59E0B" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {stats.map((stat, idx) => (
        <StatCard key={`stat-${idx}`} {...stat} />
      ))}
    </div>
  );
};

export default DashboardStats;
